<template>
  <div class="description-list--item">
    <dt>{{ term }}</dt>
    <dd>
      {{ description }}
      <slot></slot>
    </dd>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  term: string;
  description?: string;
}>();
</script>
